import type { ToastPropsInterface } from '@zillow/constellation-10';

const NotificationConstants: Record<string, ToastPropsInterface['tone']> = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  CRITICAL: 'critical',
};

export default NotificationConstants;
